<template>
  <a-select
    v-model:value="selectval"
    :options="selectOptions"
    :placeholder="props.placeholder"
    style="width: 140px"
    @change="handleUpdateSelectVal"
    allowClear
  >
  </a-select>
</template>

<script>
import { defineComponent, ref, watch } from "vue";

export default defineComponent({
  props: {
    echoVal: String,
    options: Array,
    placeholder: String,
  },
  setup(props, context) {
    const selectval = ref(null);

    const selectOptions = [];

    const handleUpdateSelectVal = () => {
      context.emit("handleUpdateSelectVal", selectval.value);
    };

    watch(
      () => props.echoVal,
      (val) => {
        selectval.value = val;
      },
      {
        immediate: true,
        deep: true,
      }
    );

    watch(
      () => props.options,
      (val) => {
        if (val) {
          selectOptions.length = 0;
          selectOptions.push(...val);
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      selectOptions,
      selectval,
      handleUpdateSelectVal,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
